// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isMatch as fn } from "../isMatch.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isMatchWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isMatchWithOptions;
